import { render, staticRenderFns } from "./ETF.vue?vue&type=template&id=3695a710"
import script from "./ETF.vue?vue&type=script&lang=js"
export * from "./ETF.vue?vue&type=script&lang=js"
import style0 from "./ETF.vue?vue&type=style&index=0&id=3695a710&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports